// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__kmtOp","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3rJWC","obliqueLine":"membershipbadge_obliqueLine__2UeJ_"};